import { render, staticRenderFns } from "./ComparatorItemsSwiper.vue?vue&type=template&id=cb0c89f8&scoped=true"
import script from "./ComparatorItemsSwiper.vue?vue&type=script&lang=js"
export * from "./ComparatorItemsSwiper.vue?vue&type=script&lang=js"
import style0 from "./ComparatorItemsSwiper.vue?vue&type=style&index=0&id=cb0c89f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0c89f8",
  null
  
)

export default component.exports